import * as React from 'react';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function RadioComponent(props) {
  return (
    <FormControlLabel
      {...props}
      control={<Radio />}
    />
  );
}
